// extracted by mini-css-extract-plugin
module.exports = {"geo-link":"_6eb00b8e53--geo-link--2o9uC"};